import { render } from "./ApplePayButton.vue?vue&type=template&id=4f0d1540"
import script from "./ApplePayButton.vue?vue&type=script&lang=js"
export * from "./ApplePayButton.vue?vue&type=script&lang=js"

import "./ApplePayButton.vue?vue&type=style&index=0&id=4f0d1540&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__